import Flex from "antd/es/flex";
import "./styles/queue.less"
import {HiOutlineArrowNarrowRight} from "react-icons/hi";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

export default function QueueItem(props: any) {

    const {xl} = useBreakpoint()

    const getStyles = () => {
        if (xl) {
            const classes = ["queue-item"]
            if (props.alert) {
                classes.push("queue-item-flash")
            }
            return classes.join(" ");
        } else {
            const classes = ["queue-item-mobile"]
            if (props.alert) {
                classes.push("queue-item-flash")
            }
            return classes.join(" ");
        }
    }

    return (
        <Flex className={getStyles()}
              justify="center" align="center">
            <Flex align={"center"} justify={"center"} gap={16}>
                <div>{`${props.number}`}</div>
                <HiOutlineArrowNarrowRight/>
                <div>{`${props.window}`}</div>
            </Flex>
        </Flex>
    )
}